import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { adsServer } from "../../server";

const SponsoredProductCarouselProps = ({ ads }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const adRefs = useRef(new Map()); // To store product refs

    const logAdClick = async (adId) => {
        try {
            await axios.post(`${adsServer}/sponsored/click/${adId}`, { withCredentials: true, 
                headers: {
                    'current-profile': sessionStorage.getItem('currentProfile') || 'defaultProfile',
                }});
            console.log('Click logged for ad:', adId);
        } catch (error) {
            console.error('Error logging click:', error);
        }
    };

    

    const logViewedImpression = async (adId) => {
        try {
            await axios.post(`${adsServer}/sponsored/viewed-impression/${adId}`, {}, { withCredentials: true, 
                headers: {
                    'current-profile': sessionStorage.getItem('currentProfile') || 'defaultProfile',
                }});
            console.log('Viewed impression logged for ad:', adId);
        } catch (error) {
            console.error('Error logging viewed impression:', error);
        }
    };

    useEffect(() => {
        if (ads.length > 0) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const adId = entry.target.dataset.adId;

                            // Start a timer for 1 second to log viewed impression
                            const timer = setTimeout(() => {
                                logViewedImpression(adId);
                            }, 1000);

                            // Store the timer in the DOM element
                            entry.target._timer = timer;
                        } else {
                            clearTimeout(entry.target._timer); // Clear the timer if the element goes out of view
                        }
                    });
                },
                { threshold: 0.5 } // 50% of the ad must be visible
            );

            const visibleAds = [ads[currentIndex]];
            if (ads.length > 1) {
                visibleAds.push(ads[(currentIndex + 1) % ads.length]);
            }

            visibleAds.filter(Boolean).forEach((ad) => {
                const adElement = adRefs.current.get(ad._id);
                if (adElement) {
                    observer.observe(adElement);
                }
            });

            return () => {
                observer.disconnect();
            };
        }
    }, [currentIndex, ads]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % ads.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + ads.length) % ads.length);
    };

    if (ads.length === 0) {
        return null;
    }

    const currentAd = ads[currentIndex];
    const visibleAds = [currentAd];
    if (ads.length > 1) {
        visibleAds.push(ads[(currentIndex + 1) % ads.length]);
    }
   

    return (
        <div className="sponsored-product-carousel">
            <div className="sponsored-carousel-track">
                {visibleAds.filter(Boolean).map((ad, index) => {
                    const imageUrl = ad.adSet.images["Sponsored Product Carousel"];

                    return (
                        <div
                            key={ad._id}
                            className={`sponsored-product-carousel-paper sponsored-carousel-card ${index > 0 ? 'sponsored-carousel-secondary-card' : ''}`}
                            data-ad-id={ad._id}
                            ref={(el) => el && adRefs.current.set(ad._id, el)}
                        >
                            <div className="sponsored-product-carousel-image-wrapper">
                                <img
                                    src={imageUrl}
                                    alt={ad.product.name}
                                    className="sponsored-product-carousel-image"
                                    style={{
                                        position: 'absolute',
                                    }}
                                />
                            </div>
                            <div className="sponsored-product-carousel-content">
                                <h2 className="sponsored-product-carousel-title">{ad.product.name}</h2>
                                <p className="sponsored-product-carousel-price">{`$${ad.product.discountPrice || ad.product.originalPrice}`}</p>
                                <Link
                                    to={`/product/${ad.product._id}`}
                                    onClick={() => logAdClick(ad._id)}
                                    className="sponsored-product-carousel-button"
                                >
                                    Buy now
                                </Link>
                            </div>
                        </div>
                    );
                })}
            </div>
            {ads.length > 1 && (
                <>
                    <button className="sponsored-carousel-nav-button sponsored-carousel-prev" onClick={prevSlide}>‹</button>
                    <button className="sponsored-carousel-nav-button sponsored-carousel-next" onClick={nextSlide}>›</button>
                </>
            )}
        </div>
    );
};

export default SponsoredProductCarouselProps;
